import { caseParamType, casesContents } from '../../data/cases';
import styles from './Cases.module.scss';

import { useSearchParams } from 'react-router-dom';

export const Cases = () => {
    const [searchParams] = useSearchParams();
    const caseParamRaw = searchParams.get('caso');

    const caseParam = (
        caseParamRaw && caseParamRaw in casesContents ? caseParamRaw : 'banpara'
    ) as caseParamType;

    const selectCase = casesContents[caseParam];

    return (
        <>
            <main className={styles.main}>
                <section className={styles.title}>
                    <div className={styles.title__text_container}>
                        <span>Projeto implementado</span>
                        <p>{selectCase.title}</p>
                    </div>
                    <div className={styles.logo}>
                        <img src={selectCase.logo} alt="Logo da empresa" />
                    </div>
                </section>

                <section className={styles.apresentacao}>
                    <div data-type="processo" className={styles.content}>
                        <h2>Desafio</h2>
                        <p>{selectCase.desafio}</p>
                    </div>
                    <div data-type="processo" className={styles.content}>
                        <h2>Solução</h2>
                        <p>{selectCase.solucao}</p>
                    </div>
                    <div data-type="processo" className={styles.content}>
                        <h2>Resultado</h2>
                        <p>{selectCase.resultado}</p>
                    </div>
                    <div className={styles.video}>
                        {selectCase.video_url && (
                            <iframe
                                width="1200"
                                height="534"
                                src={selectCase.video_url}
                                title={selectCase.video_title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            ></iframe>
                        )}
                    </div>
                </section>
            </main>
        </>
    );
};
